module.exports = __webpack_public_path__ + "static/img/logo_guoan.4c7ca653.svg";